// axios.js dosyası
import axios from "axios";
import { signalRUrl } from "../productionStatus";

let defaultUrl = signalRUrl;

function comAxiosWithToken(token = localStorage.getItem("UserToken")) {
  const comAxios = axios.create({
    baseURL: defaultUrl, // API'nin temel URL'si

    timeout: 160000, // İstek zaman aşımı (ms cinsinden)
  });
  comAxios.interceptors.request.use(
    (config) => {
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      config.headers["Content-Type"] = "application/json";
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  return comAxios;
}

export { comAxiosWithToken };
